import { useEffect, useState } from "react";
import "../admin/pages/styles/UserManagement.css";
import ToggleSwitch from "./ToggleSwitch";
import axios from "axios";

import ArrowDown from "/assets/ArrowDown.svg";
import ArrowUp from "/assets/ArrowUp.svg";

import check from "/assets/icon/Check.svg";
import state from "/state.png";
import state2 from "/state2.png";
import Warning from "/Warning.png";
import correct from "/correct.png";

import { Stepper, Step, StepLabel, styled } from "@mui/material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

const CustomConnector = styled(StepConnector)(({ theme, activeStep }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.line}`]: {
    borderColor: activeStep === 0 ? "#E4E7EC" : "#2762F8", // สีเส้นที่ต่างกันตาม step
    borderTopWidth: 2,
    borderRadius: 1,
  },
  ...(activeStep === 1 && {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#2762F8", // สีเส้นเมื่อ active
    },
  }),
}));

const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#2762F8",
  width: 20,
  height: 20,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#2762F8",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#2762F8",
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <div></div>, // ไอคอนที่ต้องการแสดง
    2: <div></div>,
  };

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </CustomStepIconRoot>
  );
}

const AddUserForm = ({ onClose, onSuccess }) => {
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [branchDropdownOpen, setBranchDropdownOpen] = useState(false);

  const [selectedBranch, setSelectedBranch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(true);

  const [selectedBrightness, setSelectedBrightness] = useState(""); // สร้างตัวแปรสำหรับเก็บค่าที่ถูกเลือก
  const newUserData = JSON.parse(sessionStorage.getItem("newUser"));
  const newselectedItems = JSON.parse(sessionStorage.getItem("selectedItems"));
  const [isConfirmationVisible, setIsConfirmationVisible] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [emailError, setEmailError] = useState("");

  const toggleSwitchState = sessionStorage.getItem("toggleSwitchState");
  const [page, setPage] = useState(1);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const handleRegistration = () => {
    const selectedItems = JSON.parse(
      sessionStorage.getItem("selectedItems") || "[]"
    );
    const userData = {
      name: newUserData.name + " " + newUserData.lastName,
      email: newUserData.email,
      phone_no: newUserData.phone,
      password: "",
      admin: "false",
      active: true,
      branchName: selectedBranch.name,
      permissions: {
        page_dashboard: true,
        page_alert: selectedItems.includes("การแจ้งเตือน"),
        page_weather: selectedItems.includes("สภาพอากาศ"),
        page_lighting: selectedItems.includes("ควบคุมไฟ"),
        page_gis: selectedItems.includes("แผนที่"),
        page_camera: selectedItems.includes("กล้อง CCTV"),
        page_display: selectedItems.includes("จอ LED"),
      },
      light_bulb_control: selectedBrightness === "ปรับค่าสว่างไฟได้" ? 3 : 2,
    };

    axios
      .post(`${import.meta.env.VITE_API_URL}/register`, userData)
      .then((response) => {
        if (response.data && response.data.userId) {
          console.log("ลงทะเบียนผู้ใช้สำเร็จ, UserID:", response.data.userId);
          setIsAddUserModalOpen(false);
          setShowAlert(true);
          setAlertMessage("เพิ่มผู้ใช้งานใหม่สำเร็จ");
          setTimeout(() => {
            setShowAlert(false);
            onClose();
            onSuccess(response.data.userId);
          }, 2000);
        } else {
          console.error("No user ID returned from the server");
          setShowAlert(true);
          setAlertMessage("ไม่สามารถรับ ID ผู้ใช้จากเซิร์ฟเวอร์ได้");
        }
      })
      .catch((error) => {
        console.error("เกิดข้อผิดพลาดในการลงทะเบียนผู้ใช้:", error);
        setShowAlert(true);
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : "เกิดข้อผิดพลาดในการลงทะเบียนผู้ใช้";
        setAlertMessage(errorMessage);
      });
  };

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  const [emailErrorStyle, setEmailErrorStyle] = useState(""); // เพิ่ม state สำหรับ class ข้อความ
  const [emailInputStyle, setEmailInputStyle] = useState("");
  const [email, setEmail] = useState("");

  const handleEmailChange = async (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail);
    if (!newEmail.trim()) {
      setEmailError("กรุณาใส่อีเมล");
      setEmailErrorStyle("error-red");
      setEmailInputStyle("input-error");
    } else if (!isValidEmail(newEmail)) {
      setEmailError("อีเมลไม่ถูกต้อง");
      setEmailErrorStyle("error-red");
      setEmailInputStyle("input-error");
    } else {
      const emailExists = await checkExistingEmailAPI(newEmail);
      if (emailExists) {
        setEmailError(`${newEmail} มีอยู่ในระบบแล้ว`);
        setEmailErrorStyle("error-red");
        setEmailInputStyle("input-error");
      } else {
        setEmailError(`สามารถใช้ ${newEmail} ได้`);
        setEmailErrorStyle("success-green");
        setEmailInputStyle("input-success");
      }
    }
  };

  // ฟังก์ชันเช็คอีเมล
  async function checkExistingEmailAPI(email) {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/check-email2`,
        {
          email,
        }
      );

      if (response.data.exists) {
        return true; // ถ้ามีอีเมลนี้ในระบบ
      } else {
        return false; // ถ้าไม่มีอีเมลนี้ในระบบ
      }
    } catch (error) {
      console.error("Error checking email existence:", error);
      return false; // กรณีเกิดข้อผิดพลาดในการติดต่อกับ API
    }
  }

  const handleConfirmButtonClick = () => {
    setIsConfirmationVisible(true);
    setIsAddUserModalOpen(false);
    setPage(2);
  };

  const handleConfirmation = (confirmed) => {
    setIsConfirmed(confirmed);
    setIsConfirmationVisible(false);
  };

  const newselectedBrightness = JSON.parse(
    sessionStorage.getItem("selectedBrightness")
  );

  const handleRadioChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedBrightness(selectedValue); // กำหนดค่าที่ถูกเลือกให้กับ selectedBrightness
  };

  const handleConfirm = async () => {
    const nameInput = document.getElementById("fnameInput").value;
    const lastNameInput = document.getElementById("lnameInput").value;
    const phoneInput = document.getElementById("phoneInput").value;
    const emailInput = document.getElementById("emailInput").value;

    // Check if all required fields are filled
    if (!nameInput || !lastNameInput || !phoneInput || !emailInput) {
      setShowAlert(true);
      setAlertMessage("กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง");
      return; // Stop execution if any required field is missing
    }

    // Check if 'selectedBranch' is present and not empty
    const selectedBranch = sessionStorage.getItem("selectedBranch");
    if (!selectedBranch) {
      setShowAlert(true);
      setAlertMessage("กรุณาเลือกสาขา");
      return; // Stop execution if no branch selected
    }

    // Check if 'selectedItems' is present and not empty
    const selectedItems = JSON.parse(
      sessionStorage.getItem("selectedItems") || "[]"
    );
    if (selectedItems.length === 0) {
      setShowAlert(true);
      setAlertMessage("กรุณาเลือกสิทธิการเข้าถึง");
      return; // Stop execution if no items selected
    }

    // Email validation
    if (emailError !== `สามารถใช้ ${emailInput} ได้`) {
      const emailInputElement = document.getElementById("emailInput");
      emailInputElement.classList.add("flash-border");

      setTimeout(() => {
        emailInputElement.classList.remove("flash-border");
      }, 1000);

      return; // Stop execution due to email error
    }

    // Check if email already exists in the system
    const emailExists = await checkExistingEmailAPI(emailInput);
    if (emailExists) {
      setEmailError(`มี ${emailInput} อยู่ในระบบแล้ว กรุณาใช้อีเมลอื่น.`);
      return; // Stop execution if email already exists
    }

    // Create an object with the user's data to be saved
    const newUser = {
      name: nameInput,
      lastName: lastNameInput,
      phone: phoneInput,
      email: emailInput,
    };

    // Save data in sessionStorage
    sessionStorage.setItem("newUser", JSON.stringify(newUser));
    sessionStorage.setItem(
      "selectedBrightness",
      JSON.stringify(selectedBrightness)
    );

    // Navigate to the next page
    setPage(2);
  };

  const toggleBranchDropdown = () => {
    setBranchDropdownOpen(!branchDropdownOpen);
  };

  const handleBranchSelect = (branch) => {
    setSelectedBranch(branch);
    setBranchDropdownOpen(false);
    sessionStorage.setItem("selectedBranch", branch.name);
  };

  const handleModalBackgroundClick = () => {
    setIsSummaryOpen(false);
  };

  const [branches, setBranches] = useState([]);

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_URL}/api/branches`)
      .then((response) => setBranches(response.data))
      .catch((error) =>
        console.error("เกิดข้อผิดพลาดในการดึงข้อมูลสาขา:", error)
      );
  }, []);

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true,
    inputStyle = ""
  ) => (
    <div className="float-label-container">
      <input
        type={type}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        className={`input-required ${inputStyle}`} // Ensure inputStyle is applied here
        required={required}
        placeholder=" "
      />
      <label htmlFor={id}>
        {label} {required && <span className="required-asterisk"> *</span>}
      </label>
    </div>
  );

  const [isPermissionsModalOpen, setIsPermissionsModalOpen] = useState(true);

  function PermissionsModal({ isOpen, onClose, branches }) {
    const [selectedPermissions, setSelectedPermissions] = useState({
      page_alert: false,
      page_weather: false,
      page_lighting: false,
      page_gis: false,
      page_camera: false,
      page_display: false,
    });
    const [selectedItems, setSelectedItems] = useState([]);

    // Define Thai page names once
    const thaiPageNames = {
      page_alert: "การแจ้งเตือน",
      page_weather: "สภาพอากาศ",
      page_lighting: "ควบคุมไฟ",
      page_gis: "แผนที่",
      page_camera: "กล้อง CCTV",
      page_display: "จอ LED",
    };

    const togglePermission = (page) => {
      setSelectedPermissions((prevPermissions) => {
        const isActive = !prevPermissions[page];
        const updatedPermissions = {
          ...prevPermissions,
          [page]: isActive,
        };

        const updatedItems = Object.entries(updatedPermissions)
          .filter(([key, value]) => value)
          .map(([key]) => thaiPageNames[key]);

        setSelectedItems(updatedItems);
        sessionStorage.setItem("selectedItems", JSON.stringify(updatedItems));

        return updatedPermissions;
      });
    };

    const toggleAllPermissions = (value) => {
      const updatedPermissions = Object.keys(selectedPermissions).reduce(
        (acc, page) => {
          acc[page] = value;
          return acc;
        },
        {}
      );

      setSelectedPermissions(updatedPermissions);

      const updatedItems = value ? Object.values(thaiPageNames) : [];
      setSelectedItems(updatedItems);
      sessionStorage.setItem("selectedItems", JSON.stringify(updatedItems));
    };

    useEffect(() => {
      const storedItems = JSON.parse(sessionStorage.getItem("selectedItems"));
      setSelectedItems(storedItems);
    }, []);

    const allSelected = Object.values(selectedPermissions).every(Boolean);

    const selectAllStyle = {
      backgroundColor: allSelected ? "#2762f8" : "transparent",
      color: allSelected ? "white" : "#D0D5DD",
      cursor: "pointer",
      padding: "0.3rem 0.8rem",
      transition: "background-color 0.3s ease, color 0.3s ease", // เพิ่มบรรทัดนี้
    };

    return (
      <div className="inputAddUser">
        <div className="wrapperShowRelative">
          <ul>
            <li
              className="first-item"
              style={selectAllStyle}
              onClick={() => toggleAllPermissions(!allSelected)}
            >
              {allSelected ? <span>✓</span> : ""} เลือกทั้งหมด
            </li>
            {Object.entries(selectedPermissions).map(([page, access]) => {
              const listItemStyle = {
                backgroundColor: access ? "#2762f8" : "transparent",
                color: access ? "white" : "#D0D5DD",
                cursor: "pointer",
                padding: "0.3rem 0.8rem",
                transition: "background-color 0.3s ease, color 0.3s ease",
              };

              return (
                <li
                  key={page}
                  style={listItemStyle}
                  onClick={() => togglePermission(page)}
                >
                  {access ? "✓" : "+"} {thaiPageNames[page]}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div>
      {isModalOpen && (
        <div className="modal-background" onClick={handleModalBackgroundClick}>
          <div className="add-user-modal">
            <h2>เพิ่มข้อมูลผู้ใช้งาน</h2>

            <div className="statebranch">
              <Stepper
                className="stepper"
                activeStep={page - 1}
                alternativeLabel
                connector={<CustomConnector activeStep={page - 1} />} // ส่ง activeStep เข้าไปใน CustomConnector
              >
                <Step key="1">
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    เพิ่มข้อมูลผู้ใช้งาน
                  </StepLabel>
                </Step>
                <Step key="2">
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    ยืนยันข้อมูลผู้ใช้งาน
                  </StepLabel>
                </Step>
              </Stepper>
            </div>
            <div className="inputAddUser">
              <p>ข้อมูลผู้ใช้งาน</p>
              {renderFloatLabelInput(
                "ชื่อ", // ตัวอย่าง label
                "text", // ประเภทของ input
                "fname", // ชื่อของ input
                "fnameInput" // ID ของ input
              )}
              {renderFloatLabelInput(
                "นามสกุล", // ตัวอย่าง label
                "text", // ประเภทของ input
                "lname", // ชื่อของ input
                "lnameInput" // ID ของ input
              )}
              {renderFloatLabelInput(
                "หมายเลขโทรศัพท์", // ตัวอย่าง label
                "text", // ประเภทของ input
                "phone", // ชื่อของ input
                "phoneInput" // ID ของ input
              )}
              {renderFloatLabelInput(
                "อีเมล", // Label
                "text", // Type of input
                "email", // Name of input
                "emailInput", // ID of input
                email, // Value managed by state
                handleEmailChange, // Change handler
                true, // Required
                emailInputStyle // Additional class for styling based on state
              )}{" "}
              {emailError && (
                <div className={`erroremail-message ${emailErrorStyle}`}>
                  {emailError}
                </div>
              )}
              {/* <div className="toggle-switch-container">
                <span>เปิด/ปิดสิทธิให้กับผู้ใช้งาน</span>
                <ToggleSwitch />
              </div> */}
            </div>
            <h2>เพิ่มสิทธิการเข้าถึง</h2>

            <div className="inputAddUser">
              <p>สิทธิเข้าถึงสาขา</p>
              <div
                className={`dropdownUser ${
                  branchDropdownOpen ? "clicked" : ""
                }`}
                onClick={toggleBranchDropdown}
              >
                {selectedBranch
                  ? selectedBranch.name
                  : "เลือกสาขาที่ต้องการเพิ่มสิทธิ"}
                <img
                  className={`arrow-icon-branch ${
                    branchDropdownOpen ? "rotate" : ""
                  }`}
                  src={ArrowDown}
                  alt="Arrow"
                />

                {branchDropdownOpen && (
                  <div className="dropdown-content-adduser">
                    {branches.map((branch, index) => (
                      <div
                        key={index}
                        onClick={() => handleBranchSelect(branch)}
                      >
                        <div className="notBlur">
                          <li>{branch.name}</li>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <p>สิทธิในการควบคุม</p>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="brightness"
                    value="ดูเท่านั้น"
                    onChange={handleRadioChange}
                    checked={selectedBrightness === "ดูเท่านั้น"} // ตรวจสอบความถูกต้อง
                  />
                  ดูเท่านั้น
                </label>
                <label>
                  <input
                    type="radio"
                    name="brightness"
                    value="ปรับค่าสว่างไฟได้"
                    onChange={handleRadioChange}
                    checked={selectedBrightness === "ปรับค่าสว่างไฟได้"} // ตรวจสอบความถูกต้อง
                  />
                  ปรับค่าสว่างไฟได้
                </label>
              </div>
              <p>เลือกสิทธิการเข้าถึงหน้าต่าง ๆ</p>
            </div>
            <PermissionsModal
              isOpen={isPermissionsModalOpen}
              onClose={() => setIsPermissionsModalOpen(false)}
              branches={branches}
            />

            <div className="button-adduser">
              <button
                className="cancel-button"
                onClick={() => {
                  onClose(); // Assuming onClose is your function to handle the close action
                  sessionStorage.removeItem("selectedItems");
                  sessionStorage.removeItem("selectedBranch");
                }}
              >
                ยกเลิก
              </button>

              <button className="confirm-button" onClick={handleConfirm}>
                ถัดไป
              </button>
            </div>
          </div>
        </div>
      )}

      {page === 2 && isModalOpen && (
        <div className="modal-background" onClick={handleModalBackgroundClick}>
          <div className="add-user-modal-summary">
            <h2>เพิ่มข้อมูลผู้ใช้งาน</h2>
            <div className="statebranch">
              <Stepper
                className="stepper"
                activeStep={page - 1}
                alternativeLabel
                connector={<CustomConnector activeStep={page - 1} />}
              >
                <Step key="1">
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    เพิ่มข้อมูลผู้ใช้งาน
                  </StepLabel>
                </Step>
                <Step key="2">
                  <StepLabel StepIconComponent={CustomStepIcon}>
                    ยืนยันข้อมูลผู้ใช้งาน
                  </StepLabel>
                </Step>
              </Stepper>
            </div>
            <div className="summary-content">
              <a>ข้อมูลผู้ใช้งาน </a>
              <p>ชื่อ นามสกุล</p>
              <h4>
                {newUserData.name} {newUserData.lastName}
              </h4>
              <div className="phone-mail">
                <span>หมายเลขโทรศัพท์ </span>
                <span>อีเมล </span>
                <strong>{newUserData.phone}</strong>
                <strong>{newUserData.email}</strong>
              </div>
              <p>สิทธิเข้าถึงสาขา</p>
              <h4> {selectedBranch.name}</h4>
              <p>สิทธิในการควบคุม </p>
              <h4>{newselectedBrightness}</h4>
              <p>เลือกสิทธิการเข้าถึงหน้าต่าง ๆ </p>
              <p>
                <li>
                  <img src={check} alt="Check" className="check" />
                  {newselectedItems.includes("เลือกทั้งหมด")
                    ? newselectedItems
                        .filter((item) => item !== "เลือกทั้งหมด")
                        .join(" / ")
                    : newselectedItems.join(" / ")}
                </li>
              </p>

              {sessionStorage.getItem("toggleSwitchState") === "true" && (
                <h3>เปิดสิทธิให้กับผู้ใช้งาน</h3>
              )}
              <div className="button-adduser">
                <button
                  className="cancel-button"
                  onClick={() => {
                    setPage(1); // This sets the page number to 1
                    sessionStorage.removeItem("selectedItems"); // This clears selectedItems from sessionStorage
                  }}
                >
                  ยกเลิก
                </button>

                <button
                  className="confirm-button"
                  onClick={() => {
                    handleConfirmButtonClick();
                  }}
                >
                  ยืนยัน
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isConfirmationVisible && (
        <div className="modal-background" onClick={handleModalBackgroundClick}>
          <div className="confirmation-popup">
            <p>ยืนยันการเพิ่มผู้ใช้งาน</p>
            <p>{`${newUserData.name} ${newUserData.lastName} ?`}</p>

            <div className="button-adduser">
              <button
                className="cancel-button"
                onClick={() => handleConfirmation(false)}
              >
                ยกเลิก
              </button>
              <button
                className="confirm-button"
                onClick={() => {
                  handleRegistration();
                  handleConfirmation(true);
                  setIsConfirmationVisible(false);
                  // แสดงหน้าต่างแจ้งเตือน
                  setShowAlert(true);
                  setAlertMessage("กำลังดำเนินการ...");
                  // ปิดหน้าต่างแจ้งเตือนหลังจาก 2 วินาที
                  setIsModalOpen(false); // เพิ่มบรรทัดนี้
                  setTimeout(() => {
                    setShowAlert(false);
                    onClose();
                    // onSuccess();
                  }, 2000);
                }}
              >
                ยืนยัน
              </button>
            </div>
          </div>
        </div>
      )}
      {showAlert && (
        <div className="BranchModal">
          <div className={`alert-container alert-success`}>
            <button
              className="close-button"
              onClick={() => setShowAlert(false)}
            >
              &times;
            </button>
            {alertMessage.includes("เกิดข้อผิดพลาดในการลงทะเบียนผู้ใช้") ||
            alertMessage.includes("กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง") ||
            alertMessage.includes("กรุณาเลือกสาขา") ||
            alertMessage.includes("กรุณาเลือกสิทธิการเข้าถึง") ? (
              <>
                {alertMessage}
                <div>
                  <img src={Warning} alt="Warning" />
                </div>
              </>
            ) : (
              <>
                {alertMessage}
                <div>
                  <img src={correct} alt="Success" />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddUserForm;
